import { ApplicationName, ShortcutName } from "@/lib/types";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type AppTypes = ApplicationName | ShortcutName;

interface DockState {
  tempDynamicDock: boolean;
  pinnedApps: AppTypes[];
}

interface DockActions {
  setTempDynamicDock: (tempDynamicDock: boolean) => void;
  addPinnedApp: (pinnedApp: AppTypes) => void;
  removePinnedApp: (pinnedApp: AppTypes) => void;
}

const useDockStoreBase = create<DockState & DockActions>()(
  persist(
    (set, get) => ({
      tempDynamicDock: false,
      pinnedApps: ["Settings", "Project Gallery", "Portfolio", "Resume"],

      // 🛠 Define actions that won't be persisted
      setTempDynamicDock: (tempDynamicDock) => set({ tempDynamicDock }),
      addPinnedApp: (pinnedApp) =>
        set((state) => ({
          pinnedApps: [...state.pinnedApps, pinnedApp],
        })),
      removePinnedApp: (name) =>
        set(() => ({
          pinnedApps: get().pinnedApps.filter((app) => app !== name),
        })),
    }),
    {
      name: "dock",
      partialize: (state) => ({
        tempDynamicDock: state.tempDynamicDock,
        pinnedApps: state.pinnedApps,
      }),
    }
  )
);

// 📦 Store hook for state
export default useDockStoreBase;
